<template lang="pug">
.stepup
  app-header.header

  //- パンくずリスト
  ul.breadcrumb
    li
      router-link(to="/") {{ $t('Home') }}
    li.active
      span {{ $t('Service Questions') }}

  .row.margin-top
    .col-sm-6.text-center.col-menu(v-if="isSystemManagement || isHumanStaff")
      router-link.btn.btn-warning.btn-lg.btn-menu(to="/service_question/questions")
        i.fa.fa-pencil-square-o
        p {{ $t('Service Questions List') }}
    .col-sm-6.text-center.col-menu
      router-link.btn.btn-success.btn-lg.btn-menu(to="/service_question/shop_results")
        i.fa.fa-line-chart
        p {{ $t('Service Questions Result List') }}
    .col-sm-6.text-center.col-menu(v-if="isSystemManagement || isHumanStaff")
      router-link.btn.btn-info.btn-lg.btn-menu(to="/service_question/movie")
        i.fa.fa-video-camera
        p 動画ファイル管理

</template>
<script>
import AppHeader from './AppHeader'

export default {
  name: 'service-question',
  computed: {
    isSystemManagement () {
      return this.$store.getters.isSystemManagement
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    },
    isShopManager () {
      return this.$store.getters.shopManager
    },
    isHumanStaff () {
      return window.localStorage.getItem('is_human_staff') === '1'
    }
  },
  components: {
    AppHeader
  }
}

</script>



// WEBPACK FOOTER //
// ServiceQuestion.vue?9083e0b6